import React from "react";
import { notify } from "@/shared/utils/notify";
import { sushiLunchProductsService } from "../../../shared/services";
import { ISushiLunchProduct } from "../../../redux/@types/sushiLunchProduct";

export const useUpdateStatusSushiLunchProduct = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const updateStatus = async (value: "active" | "inactive", id: any) => {
    if (isLoading) return;
    setIsLoading(true);
    await sushiLunchProductsService
      .patch(id, {
        status: value,
      })
      .then((res: Partial<ISushiLunchProduct>) => {
        setIsLoading(false);
        notify.success(
          `Se ha actualizado con éxito el estado del producto con id: ${res.id}`
        );
      })
      .catch((err: any) => {
        setIsLoading(false);
        notify.error(err.message);
      });
  };

  return {
    isLoading,
    updateStatus,
  };
};
